
import useActiveBillingSession from '../hooks/useActiveBillingSession';

/**
 * BillingSessionTracker — invisible component that activates the billing session hook.
 * Placed inside AuthProvider so it has access to user context.
 */
const BillingSessionTracker = () => {
  useActiveBillingSession();
  return null;
};

export default BillingSessionTracker;
